import { 
    InputWrapper, 
    TabContainer,
    ButtonContiner
} from './Tabs.styled';
import { Variable } from './component';
import RoundedIconButton from '../../../Buttons/RoundedIconButton/RoundedIconButton';
import {observer} from "mobx-react";
import {useTemplateEditorStore} from "../../hook";
import {useUserCheckPermissions} from "../../../../../hooks/useUserCheckPermissions";
import {PermissionCodes} from "../../../../../utils/enums";

const VariablesTab = observer(() => {
  const { variablesEditorStore } = useTemplateEditorStore();
  const {checkPermission} = useUserCheckPermissions();

  const addVariable = () => {
    variablesEditorStore.addVariable({
      isDefault: false,
      isMapped: false,
      isCustom: true,
      name: '',
      variable: '',
      value: '',
      origin: '',
      source: '',
      field: ''
    });
  };

  return (
    <TabContainer>
      <h1>Variable</h1>
        {(checkPermission(PermissionCodes.VARIABLES_SETUP, "VIEW")
            || checkPermission(PermissionCodes.VARIABLES_SETUP, "CREATE")
            || checkPermission(PermissionCodes.VARIABLES_SETUP, "UPDATE")) && (
          <>
            <ButtonContiner>
              {checkPermission(PermissionCodes.VARIABLES_SETUP, "CREATE") && (
                  <RoundedIconButton width='24px' height='24px' icon='circleAdd' onClick={addVariable}/>
              )}
            </ButtonContiner>
            <InputWrapper>
                {variablesEditorStore.variables.map((data) =>
                    (<Variable key={'variable-' + data.id} id={data.id} />)
                )}
            </InputWrapper>
          </>
        )}
    </TabContainer>
  );
});

export default VariablesTab